module.exports = __webpack_public_path__ + "static/total-control@3x-6dcd0999d26cf524c0d2739c31cac656.png";